import { GroupedProductionComponentInstance, ModelCategory } from '@paragon/contract-library';

import { ModelSchema } from '../ModelSchema';
import { StringProperty } from '../properties';

export const GroupedProductionComponentInstanceSchema = new ModelSchema<GroupedProductionComponentInstance>(
  'groupedProductionComponentInstance',
  {
    category: ModelCategory.ComponentDesign,
    displayName: (item) => `${item.trussName} (${item.quantity})`,

    properties: {
      guid: StringProperty.configure({ readOnly: true }),
      trussName: StringProperty.configure({ readOnly: true }),
      bundleIds: StringProperty.configure({ readOnly: true }),
    },
  },
);
